import { requests } from "../config";
import { IFavoritesPostData, IFavoritesResponse, IFavoritesTypes } from "./models/favorites";

export const Favorites = {
  getFavoritesByObjectType: (data: number | string): Promise<IFavoritesResponse> => requests.get(`favorites/${data}`, "go"),
  createFavorite: (data: IFavoritesPostData) => requests.post(`favorites`, "go", data),
  deleteFavorite: (data: IFavoritesPostData) => requests.delete(`favorites/${data.ObjectType}/${data.ObjectID }`, "go"),
  changeOrder: (data: number[]) => requests.put(`favorites/10/change_order`, "go", data)

}